import React from 'react';

import {
  Divider,
  Heading,
  HStack,
  SimpleTabView,
  Spacer,
  Tab,
  VStack,
} from '../../../core-ui';

import { FlatFeesTable } from './FlatFees/FlatFeesTable';
import { PercentageByCategory } from './PercentageByCategory';
import { RedemptionsTable } from './Redemptions/RedemptionsTable';

export function FeeSettingsPage() {
  return (
    <VStack
      px={10}
      pt={10}
      flex={1}
      minH={0}
      alignItems="stretch"
      spacing={2}
      maxHeight="100%"
    >
      <HStack minHeight="40px">
        <Heading as="h2" size="lg">
          {t('Settings')}
        </Heading>
        <Spacer />
      </HStack>
      <Divider borderColor="gray.200" />
      <VStack maxHeight="100%" pb={10}>
        <SimpleTabView
          width="100%"
          maxHeight="100%"
          tabPanelContainerProps={{ maxHeight: '90%' }}
        >
          <Tab title={t('Flat fees')} p={0}>
            <FlatFeesTable />
          </Tab>
          <Tab title={t('% by category')} p={0}>
            <PercentageByCategory />
          </Tab>
          <Tab
            title={t('Payments and redemptions')}
            p={0}
            flex={1}
            minH={0}
            alignItems="stretch"
            spacing={2}
          >
            <RedemptionsTable />
          </Tab>
        </SimpleTabView>
      </VStack>
    </VStack>
  );
}
